goog.provide('el8.appchart.permissions');

goog.require('el8.data.base');
goog.require('el8.data.currUser');

(function() {

    var isStaff = (el8Globals['USER_STAFF_TYPE'] === 'OfficeStaff');
    var isPhysician = (el8Globals['USER_STAFF_TYPE'] === 'Physician');
    var isPatient = (el8Globals['USER_STAFF_TYPE'] === 'Patient');

    var _Permissions = {
        acknowledgeRxDownloads: isPhysician,
        addressRxRequests: function(originalPrescriberId, isControlled) {
            return canAddressRxRequests(originalPrescriberId, isControlled);
        },
        prescribeMeds: function() { return canPrescribeMeds(); },
        signOrders: function() { return canSignOrders(); },
        writeMessages: isStaff || isPhysician || isPatient,
    };

    el8.appchart.permissions.allow = function(action, args) {
        var permission = _Permissions[action] || null;
        if (permission instanceof Function) {
            args = args || [];
            return permission.apply(this, args);
        }
        return permission || false;
    };

    el8.appchart.permissions.isUser = function(type) {
        return el8Globals['USER_STAFF_TYPE'] === type;
    };

    function canPrescribeMeds() {
        return isPhysician ||
            (el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace().length);
    }

    /**
     * @param {boolean} isControlled
     * @returns {boolean}
     */
    function canERX(isControlled) {
        var isAllowedToErx = isPhysician && el8Globals.FEATURES.ERx;
        if (!isControlled) {
            return isAllowedToErx;
        }

        return isAllowedToErx && el8Globals.FEATURES.MDToolboxEPCS;
    }

    /**
     * Checks if current user is a physician, has eRx powers, and is not an rx delegate of someone else
     * @param {boolean} isControlled
     * @returns {boolean}
     */
    function canERXWithoutHelp(isControlled) {
        var delegatingPhysicianIds = el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace();
        return canERX(isControlled) && !delegatingPhysicianIds.length;
    }

    /**
     * Checks if the current user is the same as the specified original prescriber
     *
     * @param {number} originalPrescriberId
     * @returns {boolean}
     */
    function isOriginalPrescriber(originalPrescriberId) {
        return el8.data.currUser.getStaffId() === originalPrescriberId;
    }

    /**
     * Checks if the current user can prescribe because they're an rx delegate of the
     * specified prescriber
     *
     * @param {number} prescriberId
     * @returns {boolean}
     */
    function isRxDelegateOfPrescriber(prescriberId) {
        var delegatingPhysicianIds = el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace();
        return _.contains(delegatingPhysicianIds, prescriberId)
    }

    /**
     * Check whether the current user is allowed to address the rx request assigned
     * to the original prescriber. The current expectation on who's allowed is:
     *
     * Not controlled rx requests
     * 1. Original prescriber
     * 2. Rx delegates
     * 3. Providers who can eRx without help
     *
     * Controlled rx requests
     * 1. Original prescriber
     * 2. Providers who can eRx without help
     *
     * NOTE: Being an rx delegate takes priority over being able to erx without help, so
     * if a provider can eRx but is an rx delegate for another provider, we'll treat the
     * provider as an rx delegate.
     *
     * @param {number} originalPrescriberId
     * @param {boolean} isControlled
     * @returns {boolean}
     */
    function canAddressRxRequests(originalPrescriberId, isControlled) {
        var canAddressBase = isOriginalPrescriber(originalPrescriberId) || canERXWithoutHelp(isControlled);
        if (isControlled) {
            return canAddressBase;
        }

        // rx delegates are also fine for not controlled
        return canAddressBase || isRxDelegateOfPrescriber(originalPrescriberId);
    }

    function canSignOrders() {
        return isPhysician ||
            (el8.data.currUser.getOrderDelegatingPhysicianIdsInWorkspace().length);
    }

})();
